var exports = {
  "k": "xdbfd91f1--6d03d0--container",
  "D": "xdbfd91f1--6d03d0--title",
};

module.exports = exports;
